<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body pb-10 pt-10">
          <div class="col-lg-11">
            <b-form @submit.stop.prevent="onSubmit">

              <!-- email-->
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.EMAIL") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="email-input" name="email-input" type="text" v-model="$v.form.email.$model" readonly>
                  </b-form-input>
                   <b-form-invalid-feedback id="name_th-live-feedback">
                    <span v-if="!$v.form.email.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <!-- fullname-->
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.FULLNAME") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="fullname-input" name="fullname-input" type="text" v-model="$v.form.fullname.$model">
                  </b-form-input>
                </b-col>
              </b-row>
              <!-- fullname-->
              <b-row class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.TYPE") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-select v-model="user_type" :options="user_type_option"></b-form-select>
                </b-col>
              </b-row>
              <b-row v-if="user_type==2" class="mb-5">
                <b-col sm="2">
                  <label>
                    <h5>
                      {{ $t("PAGE.USER.FORM.FIELDS.MOVE") }}
                    </h5>
                  </label>
                </b-col>
                <b-col sm="10">
                  <b-form-textarea id="textarea" v-model="$v.form.detail.$model" placeholder="Enter something..."
                    rows="3" max-rows="6"></b-form-textarea>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <b-button class="float-right" @click.prevent="cancel()">{{
                      $t("PAGE.DEFAULT.FORM.BTN_CANCEL")
                  }}</b-button>
                  <b-button type="submit" variant="primary" class="float-right mr-3">{{
                      $t("PAGE.DEFAULT.FORM.BTN_SUBMIT")
                  }}</b-button>
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.imgSize {
  margin-left: 30%;
  padding-top: 0.5cm;
  width: 30%;
  height: 30%;
  padding-bottom: 0.5cm;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import {
  GET_USER_DATA,
  PUT_USER_DATA
} from "@/core/services/store/user.module";
import Swal from "sweetalert2";
import { SET_IS_CLEAR_PAGINATION } from "@/core/services/store/user.module";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  data() {
    return {
      id: 0,
      user_type: 0,
      user_type_option: [{ value: 1, text: 'Admin' },
      { value: 2, text: 'User' },],
      form: {
        email: "",
        fullname: "",
        detail: '',
      },
    };
  },
  validations: {
    form: {
      email: {},
      fullname: {},
      detail: {},
      user_type: {}
    }
  },
  computed: {
    ...mapState({
      userType: state => state.auth.userType
    })
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getUser(this.id);
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: `${this.$t("MENU.USER_MANAGEMENT.USER")}`,
        route: "../../user"
      },
      { title: `${this.$t("PAGE.DEFAULT.FORM.TITLE")}` }
    ]);
  },
  methods: {
    onSubmit() {
      let formData = new FormData();
      formData.append("email", this.form.email);
      formData.append("fullname", this.form.fullname);
      formData.append("detail", this.form.detail);
      formData.append("type", this.user_type);
      this.update(this.id, formData);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    getUser(id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(GET_USER_DATA, { id })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                this.user_type = data.data.userType.id
                for (const formKey of Object.keys(this.form)) {
                  for (const dataKey of Object.keys(data.data)) {
                    if (formKey === dataKey) {
                      this.form[formKey] = data.data[formKey];
                    }
                  }
                }
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    update(id, data) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(PUT_USER_DATA, { id, data })
            .then(({ data }) => {
              Swal.close();
              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.data)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
                this.$router.push("../../user");
              } else if (data.status === "error" && data.error) {
                this.$v.$reset();
                Swal.fire({
                  icon: "error",
                  text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
                  confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                  confirmButtonColor: '#840000'
                });
              }
            })
            .catch(error => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: `${error}`,
                confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
                confirmButtonColor: '#840000'
              });
            });
        }
      });
    },
    cancel() {
      this.$store.commit(SET_IS_CLEAR_PAGINATION, { isClearPagination: false });
      this.$router.push("../../user");
    }
  }
};
</script>
